import get from 'lodash.get';

import authenticateWithChatProvider from 'actions/user/authenticateWithChatProvider';
import appEvents from 'events/app';
import userEvents from 'events/user';
import configEvents from 'events/configuration';
import initializeApp from 'actions/app/initializeApp';
import userSelectors from 'selectors/user';

export default (async function checkAuth(dispatch, getState, { chatGateway }) {
  const state = getState();
  const user = get(state, 'user');
  const authCredentials = userSelectors.getCredentials(user);
  const id = get(user, 'id');
  const hasToken = !!get(authCredentials, 'token', false);

  if (!id) {
    // TODO: [Albert] this probably shouldnt happen here and should occur upstream before checkAuth is called
    return dispatch(initializeApp);
  }

  if (!hasToken) {
    try {
      const { name, email } = user;
      const { providerId, loginDomain, orgDomain, appId } = state.app;

      const response = await chatGateway.auth({ name, email, orgDomain, loginDomain, appId, providerId });
      const { userId, jwt, gladlyCustomerId } = response.data;
      dispatch(userEvents.addUserCredentials({ userId, gladlyCustomerId, token: jwt }));
    } catch (error) {
      if (error.response) {
        if (error.response.status === 403 && error.response.data.errorCode === 'office_closed') {
          return dispatch(configEvents.closeOffice());
        }
        return dispatch(
          appEvents.serverError({ reason: error.response.status, err: get(error, 'response.data.message') })
        );
      }
      return dispatch(appEvents.serverError({ reason: 500, err: error.message || 'unexpected error occurred' }));
    }
  }

  return await dispatch(authenticateWithChatProvider);
});
